<template>
  <div>
    <div v-if="isCmsUsed === false">
      <h2>Bonus offers</h2>
      <a
        href="https://www.performancebonus.com/GPSincentive.html"
        target="_blank"
        class="promo"
        ><img
          src="assets/images/offer.png"
          width="864"
          height="453"
          alt="incentive info opens in new window"
        />
      </a>
    </div>

    <div v-if="isCmsUsed === true" v-html="rightContent"></div>
  </div>
</template>

<script>
export default {
  created() {
    this.rightContent =
      this.isCmsUsed === true &&
      this.cmsPage != undefined &&
      this.cmsPage.rightContent != null
        ? this.cmsPage.rightContent
        : "";
  },
  computed: {
    isCmsUsed: {
      get() {
        return this.$store.state.cms.isCmsUsed;
      }
    },
    cmsPage: {
      get() {
        return this.$store.state.cms.cmsPage;
      }
    }
  }
};
</script>
